import { useMountEffect } from '@react-hookz/web';
import { useState } from 'react';
// TODO Maybe move local storage to the search form config to avoid issues on SSR
// storage: {
//   get: () => {
//     localStorage.getItem(...);
//   },
//   set: (data) => {
//     localStorage.setItem(...);
//   },
// },
export const useStorage = () => {
  const [data, setData] = useState([]);
  const readFromLocalStorage = () => {
    const dataRaw = localStorage.getItem('storedSearchFormData');
    return dataRaw ? JSON.parse(dataRaw) : [];
  };
  const loadFromLocalStorage = () => {
    setData(readFromLocalStorage());
  };
  useMountEffect(() => {
    loadFromLocalStorage();
    const handleStorageChange = event => {
      if (event.key === 'storedSearchFormData') {
        loadFromLocalStorage();
      }
    };
    if (typeof window !== 'undefined') {
      window.addEventListener('storage', handleStorageChange);
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('storage', handleStorageChange);
      }
    };
  });
  const set = items => {
    localStorage.setItem('storedSearchFormData', JSON.stringify(items));
    setData(items);
  };
  const remove = index => {
    const next = Array.from(data);
    next.splice(index, 1);
    set(next);
  };
  const add = item => {
    if (!item.values.destination || item.travelType === 'holidayHomes') {
      return;
    }
    const oldData = readFromLocalStorage();
    const next = Array.from(oldData);
    const existingItemIndex = next.findIndex(({
      values: {
        destination
      }
    }) => item.values?.destination?.keyword === destination?.keyword);
    if (existingItemIndex !== -1) {
      next.splice(existingItemIndex, 1);
    }
    next.unshift(item);
    set(next);
  };
  return {
    data,
    remove,
    add
  };
};